/** @format */

import React, { useState } from 'react'
import { _$, Pagination, Table, TableColumn, TableSortValue } from '@king-design/react'
import styled from 'styled-components'
import { useHistory, useLocation } from 'react-router'
import { PageProps, initPage } from 'src/utils/interface'
import { MonitorSearch } from 'src/components'
import { useAsync } from 'react-use'
import { getServiceList } from 'src/api/ApiAIObservability'
import { TableSearch, parseTableSearchParams } from 'src/components'

interface ServiceListProps {
  className?: string
  startTime: number
  endTime: number
  region: string
}

interface SearchProps extends PageProps {
  ServiceName: string
}

const ServiceOverview: React.FC<ServiceListProps> = ({ className, startTime, endTime, region }) => {
  const history = useHistory()
  const location = useLocation()
  const [tableSort, setTableSort] = useState<TableSortValue>()

  const [search, setSearch] = useState<SearchProps>(
    () =>
      parseTableSearchParams<SearchProps>(location.search) || {
        ...initPage,
        ServiceName: ''
      }
  )

  const { value: serviceData, loading } = useAsync(async () => {
    if (startTime && endTime) {
      const result = await getServiceList({
        StartTime: startTime,
        EndTime: endTime,
        Page: search.Page,
        PageSize: search.PageSize,
        ServiceName: search.ServiceName,
        Region: region,
        Order: tableSort?.type,
        OrderBy: tableSort?.key
      })
      return {
        data: result?.Services || [],
        total: result?.TotalCount || 0
      }
    }
    return {}
  }, [startTime, endTime, search.Page, search.PageSize, search.ServiceName, tableSort, region])

  return (
    <div className={className}>
      <div className="service-list-header">
        <h2 className="service-list-header-title">{_$('服务列表')}</h2>
        <TableSearch params={search}>
          <MonitorSearch
            placeholder={_$('请输入服务名称，支持模糊搜索')}
            value={search.ServiceName}
            onChange={value => {
              setSearch({
                ...search,
                Page: 1,
                ServiceName: value
              })
            }}
          />
        </TableSearch>
      </div>
      <Table
        data={serviceData?.data || []}
        rowKey={data => data.Id}
        checkType="none"
        animation={false}
        loading={loading}
        sort={tableSort}
        onChangeSort={sort => {
          setTableSort(sort)
        }}
      >
        <TableColumn
          key="ServiceName"
          title={_$('服务名称')}
          slotTemplate={([data]) => {
            return (
              <a
                onClick={() => {
                  history.push(
                    `/monitor/aiobservability/servicedetail?serviceName=${data.ServiceName}`
                  )
                }}
              >
                {data.ServiceName}
              </a>
            )
          }}
        />
        <TableColumn key="LastServiceReportTime" sortable title={_$('最近数据上报时间')} />
        <TableColumn key="ServiceLanguage" title={_$('服务语言')} />
        <TableColumn key="IngestionSource" title={_$('采集来源')} />
        <TableColumn key="ServiceType" title={_$('服务类型')} />
      </Table>
      {serviceData !== undefined ? (
        <Pagination
          value={search.Page}
          limit={search.PageSize}
          total={serviceData?.total || 0}
          size="small"
          onChangeValue={value => {
            setSearch(state => {
              return {
                ...state,
                Page: value
              }
            })
          }}
          onChangeLimit={limit => {
            setSearch({
              ...search,
              PageSize: limit
            })
          }}
        />
      ) : null}
    </div>
  )
}

export default styled(ServiceOverview)`
  .service-list-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 16px 0;
    .service-list-header-title {
      font-size: 14px;
      font-weight: 600;
      line-height: 22px;
      color: rgba(0, 0, 0, 0.85);
    }
  }
  .k-pagination {
    margin-top: 16px;
    text-align: center;
  }
`
